function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeAlert = function SvgIconBadgeAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M12.75 14.5h-1.5V7h1.5v7.5zm0 2.5h-1.5v-1.5h1.5V17z"
  }));
};
export default SvgIconBadgeAlert;